export default {
  computed: {
    laporanVer1() {
      const monev3 = (this.monev && this.monev[3]) || {};
      const lengkapMonev3 = monev3.status_lengkap || {};

      return [
        {
          id: 1,
          nama: 'Laporan Berkala IHT 1',
          disabled: false,
        },
        {
          id: 2,
          nama: 'Laporan Berkala IHT 2',
          disabled: (this.monev[1]['k_verval_psp'] || 1) < 2,
        },
        {
          id: 2,
          nama: 'Laporan Berkala IHT 3',
          disabled: this.monev[1]['k_verval_psp'] < 2 && this.monev[2]['k_verval_psp'] < 2,
          children: {
            1: {
              id: 1,
              type: '',
              nama: 'A. Laporan Umum',
              status: (lengkapMonev3.monev && lengkapMonev3.instrumen && lengkapMonev3.berkas) || false,
              disabled:
                ((this.monev[1]['k_verval_psp'] || 1) < 2 && (this.monev[2]['k_verval_psp'] || 1) < 2) ||
                monev3.k_verval_psp > 1,
            },
            2: {
              id: 2,
              type: 'peserta',
              nama: 'B. Evaluasi Peserta',
              status: lengkapMonev3.peserta || false,
              disabled:
                ((this.monev[1]['k_verval_psp'] || 1) < 2 && (this.monev[2]['k_verval_psp'] || 1) < 2) ||
                monev3.k_verval_psp > 1,
            },
            3: {
              id: 3,
              type: 'feedback',
              nama: 'C. Rekapitulasi Evaluasi Penyelenggaraan IHT dari Peserta',
              status: lengkapMonev3.feedback || false,
              disabled:
                ((this.monev[1]['k_verval_psp'] || 1) < 2 && (this.monev[2]['k_verval_psp'] || 1) < 2) ||
                monev3.k_verval_psp > 1,
            },
            4: {
              id: 4,
              type: 'evaluasi',
              nama: 'D. Evaluasi Penyelenggaraan dan Umpan Balik',
              status: lengkapMonev3.evaluasi || false,
              disabled:
                ((this.monev[1]['k_verval_psp'] || 1) < 2 && (this.monev[2]['k_verval_psp'] || 1) < 2) ||
                monev3.k_verval_psp > 1,
            },
            5: {
              id: 5,
              type: 'administrasi',
              nama: 'E. Dokumen Administrasi Kegiatan IHT',
              status: lengkapMonev3.administrasi || false,
              disabled:
                ((this.monev[1]['k_verval_psp'] || 1) < 2 && (this.monev[2]['k_verval_psp'] || 1) < 2) ||
                monev3.k_verval_psp > 1,
            },
          },
        },
      ];
    },

    laporanVer2() {
      const monevTutup = (this.monev && this.monev[5]) || {};
      const lengkapMonevTutup = monevTutup.status_lengkap || {};

      let laporanAkhir = {
        id: 5,
        nama: 'Laporan Akhir IHT',
        disabled: this.meta.tutup || (this.$getDeepObj(this.monev, `4.k_verval_psp`) || 1) < 2,
      };

      if (this.isSmkPk) {
        laporanAkhir['children'] = {
          1: {
            id: 1,
            type: '',
            nama: 'A. Laporan Umum',
            status: (lengkapMonevTutup.monev && lengkapMonevTutup.instrumen && lengkapMonevTutup.berkas) || false,
            disabled: (this.$getDeepObj(this.monev, `4.k_verval_psp`) || 1) < 2 || lengkapMonevTutup.k_verval_psp > 1,
          },
          2: {
            id: 2,
            type: 'feedback',
            nama: 'B. Rekapitulasi Evaluasi Penyelenggaraan IHT dari Peserta',
            status: lengkapMonevTutup.feedback || false,
            disabled: (this.$getDeepObj(this.monev, `4.k_verval_psp`) || 1) < 2 || lengkapMonevTutup.k_verval_psp > 1,
          },
        };
      }

      return [
        {
          id: 4,
          nama: 'Laporan Pembukaan IHT',
          disabled: this.meta.tutup,
        },
        laporanAkhir,
      ];
    },

    laporanVer3() {
      const monev6 = (this.monev && this.monev[6]) || {};
      const monev7 = (this.monev && this.monev[7]) || {};
      const kMonev6 = monev6.k_verval_psp || 1;
      const kMonev7 = monev7.k_verval_psp || 1;
      const laporanMonev6 = monev6.status_laporan || {};
      const lengkapMonev6 = monev6.status_lengkap || {};
      const laporanMonev7 = monev7.status_laporan || {};
      const lengkapMonev7 = monev7.status_lengkap || {};

      return [
        {
          id: 6,
          nama: 'Laporan Pembukaan IHT',
          disabled: this.meta.tutup || kMonev7 >= 2,
          children: {
            1: {
              id: 1,
              type: 'umum',
              nama: 'A. Laporan Umum',
              status:
                (laporanMonev6.monev && lengkapMonev6.monev && laporanMonev6.berkas && lengkapMonev6.berkas) || false,
              tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
              disabled: this.meta.tutup || kMonev7 >= 2,
              view: this.$isObject(monev6),
            },
            2: {
              id: 2,
              type: 'partisipan',
              nama: 'B. Sasaran dan Pengajar IHT',
              status:
                (laporanMonev6.sasaran && lengkapMonev6.sasaran && laporanMonev6.pengajar && lengkapMonev6.pengajar) ||
                false,
              tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
              disabled: this.meta.tutup || kMonev7 >= 2 || monev6.is_terlaksana !== 1,
              view: this.$isObject(monev6) && monev6.is_terlaksana,
            },
          },
        },
        {
          id: 7,
          type: 'umum',
          nama: 'Laporan Akhir IHT',
          tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
          disabled: this.meta.tutup || (kMonev6 < 2 && kMonev7 < 2) || monev6.is_terlaksana !== 1,
          children: {
            1: {
              id: 1,
              type: 'umum',
              nama: 'A. Laporan Umum',
              status:
                (kMonev6 >= 2 &&
                  laporanMonev7.monev &&
                  lengkapMonev7.monev &&
                  laporanMonev7.berkas &&
                  lengkapMonev7.berkas &&
                  laporanMonev7.instrumen &&
                  lengkapMonev7.instrumen) ||
                false,
              tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
              disabled: this.meta.tutup || kMonev7.k_verval_psp >= 2,
              view: this.$isObject(monev7),
            },
            2: {
              id: 2,
              type: 'partisipan',
              nama: 'B. Sasaran dan Pengajar IHT',
              status:
                (kMonev6 >= 2 &&
                  laporanMonev7.sasaran &&
                  lengkapMonev7.sasaran &&
                  laporanMonev7.pengajar &&
                  lengkapMonev7.pengajar) ||
                false,
              tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
              disabled: this.meta.tutup || kMonev7.k_verval_psp >= 2 || monev6.is_terlaksana !== 1,
              view: this.$isObject(monev7),
              desc:
                'Jika terdapat perubahan data Sasaran dan Pengajar IHT dari Laporan Awal, silahkan perbarui data Sasaran dan Pengajar IHT',
            },
          },
        },
      ];
    },

    laporanVer3Smk() {
      const monev6 = (this.monev && this.monev[6]) || {};
      const monev7 = (this.monev && this.monev[7]) || {};
      const monev8 = (this.monev && this.monev[8]) || {};
      const kMonev6 = monev6.k_verval_psp || 1;
      const kMonev7 = monev7.k_verval_psp || 1;
      const kMonev8 = monev8.k_verval_psp || 1;
      const laporanMonev6 = monev6.status_laporan || {};
      const lengkapMonev6 = monev6.status_lengkap || {};
      const laporanMonev7 = monev7.status_laporan || {};
      const lengkapMonev7 = monev7.status_lengkap || {};
      const lengkapMonev8 = monev8.status_lengkap || {};

      return [
        {
          id: 6,
          nama: 'Laporan Pembukaan IHT',
          disabled: this.meta.tutup || kMonev7 >= 2,
          children: {
            1: {
              id: 1,
              type: 'umum',
              nama: 'A. Laporan Umum',
              status:
                (laporanMonev6.monev && lengkapMonev6.monev && laporanMonev6.berkas && lengkapMonev6.berkas) || false,
              tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
              disabled: this.meta.tutup || kMonev7 >= 2,
              view: this.$isObject(monev6),
            },
            2: {
              id: 2,
              type: 'partisipan',
              nama: 'B. Sasaran dan Pengajar IHT',
              status:
                (laporanMonev6.sasaran && lengkapMonev6.sasaran && laporanMonev6.pengajar && lengkapMonev6.pengajar) ||
                false,
              tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
              disabled: this.meta.tutup || kMonev7 >= 2 || monev6.is_terlaksana !== 1,
              view: this.$isObject(monev6) && monev6.is_terlaksana,
            },
          },
        },
        {
          id: 7,
          type: 'umum',
          nama: 'Laporan Akhir IHT',
          tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
          disabled: this.meta.tutup || (kMonev6 < 2 && kMonev7 < 2) || monev6.is_terlaksana !== 1,
          children: {
            1: {
              id: 1,
              type: 'umum',
              nama: 'A. Laporan Umum',
              status:
                (kMonev6 >= 2 &&
                  laporanMonev7.monev &&
                  lengkapMonev7.monev &&
                  laporanMonev7.berkas &&
                  lengkapMonev7.berkas &&
                  laporanMonev7.instrumen &&
                  lengkapMonev7.instrumen) ||
                false,
              tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
              disabled: this.meta.tutup || kMonev7.k_verval_psp >= 2,
              view: this.$isObject(monev7),
            },
            2: {
              id: 2,
              type: 'partisipan',
              nama: 'B. Sasaran dan Pengajar IHT',
              status:
                (kMonev6 >= 2 &&
                  laporanMonev7.sasaran &&
                  lengkapMonev7.sasaran &&
                  laporanMonev7.pengajar &&
                  lengkapMonev7.pengajar) ||
                false,
              tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
              disabled: this.meta.tutup || kMonev7.k_verval_psp >= 2 || monev6.is_terlaksana !== 1,
              view: this.$isObject(monev7),
              desc:
                'Jika terdapat perubahan data Sasaran dan Pengajar IHT dari Laporan Awal, silahkan perbarui data Sasaran dan Pengajar IHT',
            },
          },
        },
        {
          id: 8,
          type: 'umum',
          nama: 'Laporan Evaluasi IHT',
          tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
          disabled: this.meta.tutup || (kMonev7 < 2 && kMonev8 < 2) || monev6.is_terlaksana !== 1,
          children: {
            1: {
              id: 1,
              type: 'partisipan-ujian',
              nama: 'A. Nilai Pretest dan Posttest',
              status: (kMonev7 >= 2 && lengkapMonev8.ujian) || false,
              tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
              disabled: this.meta.tutup || kMonev8.k_verval_psp >= 2,
              view: this.$isObject(monev8),
            },
            2: {
              id: 1,
              type: 'evaluasi-pelaksanaan',
              nama: 'B. Evaluasi Pelaksanaan IHT',
              status: (kMonev7 >= 2 && lengkapMonev8.pelaksanaan) || false,
              tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
              disabled: this.meta.tutup || kMonev8.k_verval_psp >= 2,
              view: this.$isObject(monev8),
            },
            3: {
              id: 2,
              type: 'evaluasi-pip',
              nama: 'C. Evaluasi PIP IHT',
              status: (kMonev7 >= 2 && lengkapMonev8.pip) || false,
              tidakLapor: !monev6.is_terlaksana && this.$isObject(monev6),
              disabled: this.meta.tutup || kMonev8.k_verval_psp >= 2 || monev6.is_terlaksana !== 1,
              view: this.$isObject(monev8),
            },
          },
        },
      ];
    },
  },
};
